export default __webpack_public_path__ + "static/media/img-hero-desktop-02-organic.62b81332.jpg";